<template>
  <!-- custom sort sem ordenação pois a ordenção já é feita previamente no back -->
  <v-layout>
    <v-flex md12 style="overflow: auto">
      <v-data-table
        :loading="loading"
        no-data-text="Nenhuma tarefa encontrada por aqui"
        rows-per-page-text="Registros por página"
        item-key="id"
        :headers="headers"
        disable-initial-sort
        style="margin-bottom: 10px!important;"
        :items="items"
        v-model="items"
        class="elevation-1"
        :hide-actions="true"
        :pagination.sync="pagination"
        :hide-headers="!task_top">
        <!-- v-slot:no-data usando para o usuário adicionar tarefas quando não possui registros -->
        <template v-slot:no-data>
          <tr v-if="addTask" id='addTask' class="task-item">
            <td :colspan="!dontShowSubtasks ? 11 : 10">
              <v-layout align-center justify-space-between row fill-height>
                <v-text-field maxlength="190" style="padding-bottom: 10px!important;" counter="190" @keyup.native.enter="doneAddTask" @keyup.native.esc="closeAddTask" ref="addTaskTextField"  placeholder="Digite a descrição da Tarefa" :rules="requiredRule(translate('table.tasks.field.id_text'),190)" v-model="newTaskId_text" @blur="textFieldBlur"></v-text-field>
                <v-btn @click="doneAddTask" :loading="loadingAddTask" fab small icon class="mx-0">
                  <v-icon medium>done</v-icon>
                </v-btn>
                <v-btn @click="closeAddTask" fab small icon class="mx-0">
                  <v-icon medium>close</v-icon>
                </v-btn>
              </v-layout>
            </td>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr v-if="props.index === 0" v-show="addTask" id='addTask' class="task-item">
            <td :colspan="!dontShowSubtasks ? 11 : 10">
              <v-layout align-center justify-space-between row fill-height>
                <v-text-field style="padding-bottom: 10px!important;" maxlength="190" counter="190" @keyup.native.enter="doneAddTask" @keyup.native.esc="closeAddTask" ref="addTaskTextField"  placeholder="Digite a descrição da Tarefa" :rules="requiredRule(translate('table.tasks.field.id_text'),190)" v-model="newTaskId_text" @blur="textFieldBlur"></v-text-field>
                <v-btn @click="doneAddTask" :loading="loadingAddTask" fab small icon class="mx-0">
                  <v-icon medium>done</v-icon>
                </v-btn>
                <v-btn @click="closeAddTask" fab small icon class="mx-0">
                  <v-icon medium>close</v-icon>
                </v-btn>
              </v-layout>
            </td>
          </tr>
          <tr data-v-78d32030
              @click="clicked(props.item.id)"
              :id="'line'+props.item.id"
          >
            <td v-if="!dontShowSubtasks" :id="'subExpand'+props.item.id" @click="openSubtasks(props)">
              <p-subtask-progress :type="1" :task_id="props.item.id" :finalizedQuantity="props.item.finalized_subtasks" :subtasksQuantity="props.item.subtasks_clean_count"></p-subtask-progress>
            </td>
            <td>
              <v-layout row>
                <span>{{props.item.identifier_sequence}}</span>
                <div v-if="props.item.company_id !== $auth.user().company_id">
                  <v-tooltip right>
                    <v-avatar v-if="props.item.company.logo_path" slot="activator" size="20px">
                      <img :src="`${basePath}uploads/companies/${props.item.company.logo_path}`" alt="avatar">
                    </v-avatar>
                    <v-avatar v-else slot="activator" size="20px" class="avatar">
                      <span class="avatar-letters"> {{ getFirstLetters(((props.item.company_id !== $auth.user().company_id) && props.item.company) ? props.item.company.id_text : '') }} </span>
                    </v-avatar>
                    <span> {{ ((props.item.company_id !== $auth.user().company_id) && props.item.company) ? props.item.company.id_text : '' }} </span>
                  </v-tooltip>
                </div>
              </v-layout>
            </td>
            <td @click="editSubItem(props.item, 4)">
              <v-tooltip bottom>
                <!-- <router-link class="task-text"  slot="activator" :to="{ name: 'Task', params: { id: props.item.id}, query: { return: 'tasks' }}">{{ props.item.id_text | formatAbbreviation(70) }}</router-link> -->
                <a class="task-text"  slot="activator">{{ props.item.id_text | formatAbbreviation(70) }}</a>
                <span><p-entire-field :field="props.item.id_text"></p-entire-field></span>
              </v-tooltip>
            </td>
            <!-- Responsável da Tarefa -->
            <td v-if="!props.item.user">
              {{''}}
            </td>
            <td align="center" v-else-if="props.item.company_id === $auth.user().company_id">
              <v-tooltip bottom>
                <v-avatar v-if="props.item.user.photo_path" slot="activator" size="42px" class="mr-3">
                  <img :src="`${basePath}uploads/users/${props.item.user.photo_path}`" alt="Avatar">
                </v-avatar>
                <v-avatar v-else slot="activator" size="42px" class="avatar mr-3">
                  <span class="avatar-letters"> {{ getFirstLetters(props.item.user.id_text) }} </span>
                </v-avatar>
                <span>{{ props.item.user.id_text+(props.item.connection_company ? ('('+props.item.connection_company.id_text+')') : '')}}</span>
              </v-tooltip>
            </td>
            <td align="center" v-else-if="props.item.connection_company_id">
              <v-tooltip bottom>
                <v-avatar v-if="props.item.user.photo_path" slot="activator" size="42px" class="mr-3">
                  <img :src="`${basePath}uploads/users/${props.item.user.photo_path}`" alt="Avatar">
                </v-avatar>
                <v-avatar v-else slot="activator" size="42px" class="avatar mr-3">
                  <span class="avatar-letters"> {{ getFirstLetters(props.item.user.id_text) }} </span>
                </v-avatar>
                <span>{{ props.item.user.id_text+(props.item.connection_company_id === $auth.user().company_id ? '' : ('('+props.item.connection_company.id_text+')')) }}</span>
              </v-tooltip>
            </td>
            <td align="center" v-else>
              <v-tooltip bottom>
                <v-avatar v-if="props.item.user.photo_path" slot="activator" size="42px" class="mr-3">
                  <img :src="`${basePath}uploads/users/${props.item.user.photo_path}`" alt="Avatar">
                </v-avatar>
                <v-avatar v-else slot="activator" size="42px" class="avatar mr-3">
                  <span class="avatar-letters"> {{ getFirstLetters(props.item.user.id_text) }} </span>
                </v-avatar>
                <span>{{ props.item.user.id_text+((' ('+props.item.company.id_text+')'))}}</span>
              </v-tooltip>
            </td>
            <!-- Fim Responsável da Tarefa -->
            <td align="center">
              <v-tooltip bottom v-if="props.item.client_id">
                <v-avatar v-if="props.item.client.auto && props.item.client.connection_company && props.item.client.connection_company.logo_path" size="36px" slot="activator">
                  <img :src="`${basePath}uploads/companies/${props.item.client.connection_company.logo_path}`" alt="a23vatar">
                </v-avatar>
                <v-avatar v-else-if="!props.item.client.auto && props.item.client.logo_path" size="36px" slot="activator">
                  <img :src="`${basePath}uploads/connections/${props.item.client.logo_path}`" alt="a23vatar">
                </v-avatar>
                <v-avatar v-else class="avatar" size="36px" slot="activator">
                  <span class="avatar-letters"> {{ getFirstLetters(props.item.client.id_text) }} </span>
                </v-avatar>
                <span> {{ props.item.client_id ? props.item.client.id_text : '' }} </span>
              </v-tooltip>
            </td>
            <td align="right">
              <p-task-date-icon
                :begin="props.item.begin"
                :end="props.item.end"
                :isMobileDesign="true"
                :status_date="props.item.status_date"
                :commitment="props.item.commitment"
                :isFinalized="(props.item.status && props.item.status.identifier === 3)"
              ></p-task-date-icon>
            </td>
            <td id="status">
              <p-select-Status
              @change="val => changeStatusProcess(val, props.item)"
              :status="props.item.status"
              :companyId="props.item.company_id"
              :task_id="props.item.id"
              :task="props.item"
              ></p-select-Status>
            </td>
            <td align="center">
              <v-tooltip bottom>
                <v-avatar slot="activator" v-if="props.item.team_id" size="35" :color="props.item.team.color || 'primary'">
                  <span class="avatar-letters"> {{ props.item.team_id ? getFirstLetters(props.item.team.id_text) : '' }} </span>
                </v-avatar>
                <span> {{ props.item.team_id ? props.item.team.id_text : '' }} </span>
              </v-tooltip>
            </td>
            <td align="center">
              <v-tooltip bottom>
                <v-avatar slot="activator" v-if="props.item.urgency" size="35" :color="translate('value.task_urgency').find((val)=>{ return val.value === props.item.urgency }).color">
                  {{ translate('value.task_urgency').find((val)=>{ return val.value === props.item.urgency }).text.charAt(0) }}
                </v-avatar>
                <span> {{ props.item.urgency ? translate('value.task_urgency').find((val)=>{ return val.value === props.item.urgency }).text : '' }} </span>
              </v-tooltip>
            </td>
            <!-- <td align="center">
              <v-tooltip bottom v-if="props.item.company_id !== $auth.user().company_id">
                <v-avatar v-if="props.item.company.logo_path" slot="activator" size="36px">
                  <img :src="`${basePath}uploads/companies/${props.item.company.logo_path}`" alt="avatar">
                </v-avatar>
                <v-avatar v-else slot="activator" size="36px" class="avatar">
                  <i style="font-size: 1.5em" class="fas fa-building"></i>
                </v-avatar>
                <span><p-entire-field :field="(((props.item.company_id !== $auth.user().company_id) && props.item.company) ? props.item.company.id_text : '')"></p-entire-field></span>
              </v-tooltip>
            </td> -->
            <td align="center">
              <v-layout align-center justify-center>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon class="mx-0" @click="startDuration(props.item)" :disabled="(checkIsFree() && props.item.company_id != $auth.user().company_id)">
                    <v-icon color="purple">alarm</v-icon>
                  </v-btn>
                  <span>Iniciar Tempo</span>
                </v-tooltip>
                <v-menu
                  left
                  nudge-top="8"
                  content-class="elevation-0 menu_content"
                  transition="slide-x-reverse-transition"
                  :offset-x="true"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :id="'task_more_btn_'+props.index" fab small icon class="mx-0" v-on="on">
                      <v-icon medium>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-tooltip bottom>
                    <v-btn  :id="'task_edit_btn_'+props.index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="editSubItem(props.item, 4)" :disabled="!checkPermission(entity, 'manage')">
                      <v-icon color="teal">build</v-icon>
                    </v-btn>
                    <span>{{manageTooltipText}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn :id="'task_delete_btn_'+props.index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="deleteSubItem(props.item)" :disabled="!checkPermission(entity, 'delete')">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                    <span>{{deleteTooltipText}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn :id="'task_add_subtask_btn_'+props.index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="createSubItem(props.item)" :disabled="!checkPermission(entity, 'create')">
                      <v-icon color="green">add</v-icon>
                    </v-btn>
                    <span>{{createTooltipText}} subtarefas.</span>
                  </v-tooltip>
                  <v-tooltip v-if="!selectedConnection" bottom>
                    <v-btn :id="'task_duplicate_btn_'+props.index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="duplicateTask(props.item.id)" :disabled="!checkPermission(entity, 'create') || props.item.company_id !== $auth.user().company_id">
                      <v-icon color="purple">file_copy</v-icon>
                    </v-btn>
                    <span>{{checkPermission(entity, 'create') ? props.item.company_id !== $auth.user().company_id ? 'Não é possivel duplicar tarefa de outra Empresa' : 'Duplicar' : 'Sem permisão para duplicar'}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-menu offset-y slot="activator" bottom>
                      <v-btn :id="'task_report_btn_'+props.index" @click="openReportDialog(props.item.id, props.item.id_text)" slot="activator" small color="grey lighten-4" fab class="mx-0" :disabled="!checkPermission('report_task', 'view')">
                        <v-icon color="orange">library_books</v-icon>
                      </v-btn>
                      <v-list>
                        <v-list-tile
                          :key="0" :id="'task_duration_btn_'+props.index">
                          <v-list-tile-title>Duração</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                    <span>{{checkPermission('report_task', 'view') ? 'Relatório' : 'Você não tem permissão para visualizar'}}</span>
                  </v-tooltip>
                  <!-- Documento Personalizado -->
                  <v-tooltip bottom v-if="props.item['tasktemplate_id'] && props.item['company_id'] === $auth.user().company_id && props.item['level'] == 1">
                    <v-btn small fab class="mx-0" slot="activator" @click="$emit('openDocumentPreviewList', props.item['id'], props.item['tasktemplate_id'])">
                      <v-icon color="blue">description</v-icon>
                    </v-btn>
                    <span>Documentos Personalizados</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <p-request-more-fields slot="activator" :task_id="props.item.id"></p-request-more-fields>
                    <span>Mais campos</span>
                  </v-tooltip>
                </v-menu>
              </v-layout>
            </td>
          </tr>
          <!-- Passando props para o componente PTaskFather ao invés de utilizar "ref" porque ocorria um problema ao tentar gerar um relatório de tarefas filtradas. Foi alterado a estrutura para a geração de relatórios de tarefas. -->
        </template>
        <template v-if="!dontShowSubtasks && (props.item.subtasks_clean_count > 0 || fatherId === props.item.id)" slot="expand" slot-scope="props">
          <v-card>
            <v-card-text class="grey lighten-2">
              <!-- // passa :select null para mostrar todas as subtarefas e não so 25 -->
              <p-task-expand ref="expand" @changeAllItem="changeAllItem" @sequenceExpanded="sequenceExpanded" @createSubItem="createSubItem" @doneNewTask="(item) => {$emit('doneNewTask', item)}" @duplicateTask="duplicateTask" @editSubItem="editSubItem" @deleteSubItem="deleteSubItem" @openDocumentPreview="(taskId, documentId) => $emit('openDocumentPreview', taskId, documentId)" :headers="headers" :itemFather="props.item" :items="props.item.all_subtasks" :select="-1" :task_top="false">
              </p-task-expand>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>
<style scoped>
  .speed-dial {
    display:inline !important;
    /*float:right !important;*/
  }
  .menu_content {
    padding: 0 10px 10px 10px;
    min-width: 360px!important;
  }
  .avatar{
    background: linear-gradient(to right, #00F260 , #0575E6);
    color: #fff;
  }

  .clicked {
    background-color: #b3d4fc;
  }

  #status a {
    margin: auto !important;
  }

  #status button {
    padding: 0 !important;
  }

  .task-outdate {
    color: #d40505;
  }

  .avatar-letters {
    font-weight: bold;
    color: #fff;
    font-size: 1.2em;
  }
</style>
<script>
  import access from '../../mixin/access'
  import general from '../../mixin/general'
  import rules from '../../mixin/rules'
  import plan from '../../mixin/plan'
  import PTaskDateIcon from './../shared/PTaskDateIcon'
  import PSubtaskProgress from './../shared/PSubtaskProgress'
  import tooltip from '../../mixin/tooltip'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  import PRequestMoreFields from './../shared/PRequestMoreFields'
  import PEntireField from './../shared/PEntireField'
  // Tirado o pShareTask pois ele esta dentro de um speedDial não deixando ele aparecer
  // import PShareTask from './../shared/PShareTask'
  import PSelectStatus from './../shared/PSelectStatus'
  import PTaskFather from './../../components/reports/PTaskFather'

  momentDurationFormatSetup(moment)
  export default {
    mixins: [access, general, rules, tooltip, plan],
    props: {
      select: {
        default: 25
      },
      dontShowSubtasks: false,
      loading: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array
      },
      itemFather: {
        type: Object
      },
      headers: {
        type: Array
      },
      selectedConnection: {
        type: Boolean
      },
      task_top: {
        type: Boolean,
        default: true
      }
    },
    components: {PTaskDateIcon, PRequestMoreFields, PSubtaskProgress, PEntireField, PTaskFather, PSelectStatus},
    name: 'p-task-expand',
    data () {
      return {
        entity: 'tasks',
        sequenceExpandedIds: '',
        recalculate: false,
        pagination: {},
        newTaskId_text: '',
        fatherId: null,
        insertItem: {},
        clickInsert: false,
        addTask: false,
        loadingAddTask: false,
        loadingSubtasks: false,
        basePath: process.env.API,
        report_link: `${process.env.API}api/report/task_father`
      }
    },
    mounted () {
      this.pagination.rowsPerPage = this.select
    },
    methods: {
      openReportDialog (taskId = '', idtext = null) {
        this.$store.commit('reportDialog/change_values', {
          showDialog: true,
          reportDialogLoading: true,
          reportDialogTasks: [{id: taskId, id_text: idtext}],
          reportDialogEditedItem: {task_id: taskId, id_text: idtext, begin: !this.checkIsFree() ? '' : moment().format('YYYY-MM-DD 00:00'), end: !this.checkIsFree() ? '' : moment().format('YYYY-MM-DD 23:59')},
          reportDialogDisable: true,
          selectedTask: false,
          disableTasks: true
        })
        if (taskId !== '') {
          this.$store.commit('reportDialog/change_values', {reportDialogLoading: false, disableTasks: true, selectedTask: true})
        } else {
          this.$http.get(`api/tasksReport`).then(res => {
            this.$store.commit('reportDialog/change_values', {
              reportDialogTasks: res.body,
              reportDialogLoading: false,
              reportDialogDisable: false
            })
          })
        }
      },
      changeStatus: function (val, item, items) {
        item.task_status_id = val.id
        let value = {id: item.id, task_status_id: (item.task_status_id || null)}
        let name = this.translate('table.' + this.entity + '.title')[0]
        this.$store.commit('loader/change_dialog', true)
        this.$http.put(`api/${this.entity}/${value.id}`, value).then(
          (res) => {
            // Tira o allsubtasks para não substituir as subtarefas por vazio
            delete res.body.all_subtasks
            Object.assign(items.find((res) => { return res.id === value.id }) || {}, res.body)
            //* Enviando evento para o servidor socket para atualizar o status da tarefa em tempo real
            delete res.body.recurrence
            // before_status_identifier verifica se houve mudança de identifier do status e armazena o antigo, caso haja alteraçção e o atual é 3 manda socket para calendario
            if (!!res.body.before_status_identifier && res.body.status.identifier === 3) {
              for (var element in res.body.participants) {
                this.$socket.emit('generalEvent', {
                  data: res.body,
                  responseEvent: 'deleteSocketCalendarTask',
                  room: `calendar${res.body.participants[element]}`
                })
              }
            }
            // caso haja mudança e o identifier antigo é de finalizado addiciona o via socket a tarefa no calendario
            if (!!res.body.before_status_identifier && res.body.before_status_identifier === 3) {
              for (element in res.body.participants) {
                this.$socket.emit('generalEvent', {
                  data: res.body,
                  responseEvent: 'addSocketCalendarTask',
                  room: `calendar${res.body.participants[element]}`
                })
              }
            }
            if (res.body.level === 1) {
              for (let user in res.body.participants) {
                this.$socket.emit('generalEvent', {
                  data: {id: res.body.id, status: res.body.status, participants: res.body.participants},
                  responseEvent: 'editSocketItem',
                  room: `tasks${res.body.participants[user]}`
                })
              }
              this.$socket.emit('generalEvent', {
                data: {values: res.body, entity: 'tarefa'},
                responseEvent: 'editSocketManagementDetails',
                room: `tasks${res.body.id}_manage`
              })
            } else {
              for (let user in res.body.participants) {
                this.$socket.emit('generalEvent', {
                  data: {id: res.body.id, status: res.body.status, participants: res.body.participants, old_user_id: res.body.old_user_id, user_id: res.body.user_id, top_id: res.body.top_id, task_id: res.body.task_id, tree_task_sequence: res.body.tree_task_sequence},
                  responseEvent: 'editSubTask',
                  room: `tasks${res.body.participants[user]}`
                })
              }
              this.$socket.emit('generalEvent', {
                data: {values: res.body, entity: 'tarefa'},
                responseEvent: 'editSocketManagementDetails',
                room: `tasks${res.body.id}_manage`
              })
            }
            for (let user in res.body.participants) {
              this.$socket.emit('generalEvent', {
                data: res.body,
                responseEvent: 'editSocketCalendarTask',
                room: `calendar${res.body.participants[user]}`
              })
            }
            // fecha o dialog quando clica para mudar o status
            // this.$refs[`editDialogStatus${item.id}`].isActive = false
            // se for de level 1 irá reprocessar o filtro
            this.$emit('changeAllItem', item, item.level === 1)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro' + (name === '' ? name : ' de ' + name) + ' editado com sucesso!', color: 'success', dialog: true
            })
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível editar o registro' +
              (name === '' ? ' de ' + name : name) + ', reporte o erro.',
              color: 'error',
              dialog: true
            })
          }
        )
      },
      textFieldBlur () {
        setTimeout(() => {
          if (!this.clickInsert) this.closeAddTask()
          this.clickInsert = false
        }, 200)
      },
      openAddTask (item = null) {
        let selectedBoard = this.$store.getters[`selectedBoard/values`]
        if (selectedBoard['company_id'] !== this.$auth.user().company_id) {
          this.$store.commit('snackbar/change_values', {
            text: 'Não é possível adicionar tarefas em empresas parceiras!',
            color: 'warning',
            dialog: true
          })
          return
        }
        this.addTask = true
        this.$store.dispatch('selectedBoard/propertiesAddTask').then((response) => {
          // complementItem, serve pra quando terá algum item que será adicionado de complemento, no caso dos itens do board por exemplo, ou a tarefa modelo quando tiver vinculada com o quadro
          let complementItem = JSON.parse(JSON.stringify(response['values']))
          if (item === null) {
            this.insertItem = Object.assign({identifier: '', user_id: this.$auth.user().id, user_index: '', connection_id: null, connection_company_id: null, team_id: '', category_id: '', tasktemplate_id: null, client_id: '', task_status_id: '', id_text: this.newTaskId_text, begin: '', end: '', urgency: '', note: '', recurrence: {type: '', id_text: {each: '', days: '', months: '', daysToCreate: 1}}, password: '', shared: false, sons: [], identifier_sequence: '', level: 1}, complementItem)
            if (complementItem['tasktemplate']) {
              // tirar alguns valores que não devem ir para a tarefa
              let tasktemplate = complementItem['tasktemplate']
              delete tasktemplate.top_id
              delete tasktemplate.identifier
              delete tasktemplate.id_text
              delete tasktemplate.tasktemplate_id
              Object.assign(this.insertItem, tasktemplate, complementItem)
            }
            // Caso tenha cliente coloca ele em cochetes, pois quando estava indo no adicionar rápido, o validate estava travando pois o campo cliente estar como integer normal
            if (this.insertItem['client_id'] && !Array.isArray(this.insertItem['client_id'])) this.insertItem['client_id'] = [this.insertItem['client_id']]
          // subtarefas
          } else {
            // quando é subtarefa não busca os dados da do filtro (complementItem)
            this.insertItem = Object.assign({identifier: '', user_id: (item.company_id === this.$auth.user().company_id ? this.$auth.user().id : null), connection_id: null, connection_company_id: null, team_id: item.team_id, company_id: item.company_id, category_id: '', tasktemplate_id: item.tasktemplate_id, client_id: item.client_id, task_status_id: '', id_text: '', begin: '', end: '', urgency: '', note: '', task_id: item.id, top_id: item.top_id, recurrence: {type: '', id_text: {each: '', days: '', months: '', daysToCreate: 1}}, password: '', shared: false, sons: [], identifier_sequence: '', level: item.level + 1})
          }
          this.newTaskId_text = ''
          this.focusAddTask()
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros, reporte o erro!`,
            color: 'error',
            dialog: true
          })
          this.$store.commit('loader/change_dialog', false)
        })
      },
      // função feita para confirmar inserção de tarefas rapida
      doneAddTask () {
        this.loadingAddTask = true
        // coloca o loading no confirmar por 2 segundos, so pra mostrar que está salvando
        setTimeout(() => {
          this.loadingAddTask = false
        }, 2000)
        this.clickInsert = true
        if (this.newTaskId_text !== '') {
          let newItem = this.insertItem
          newItem.id_text = this.newTaskId_text
          this.$emit('doneNewTask', newItem)
          this.newTaskId_text = ''
          this.$refs.addTaskTextField.focus()
          this.$refs.addTaskTextField.resetValidation()
        }
      },
      // função para cancelar a parte do componente de inserção rapida de tarefas
      closeAddTask () {
        this.newTaskId_text = ''
        this.addTask = false
      },
      focusAddTask () {
        setTimeout(() => {
          if (this.$refs.addTaskTextField) this.$refs.addTaskTextField.focus()
        }, 200)
      },
      changeStatusProcess (value, item) {
        item.status = value
        item.task_status_id = value ? value.id : null
        // Caso tenha o changeUser significa que foi alterado para um status que deve altarar o responsável, portanto alterar o responsável no front
        if (item.status['changeUser']) {
          Object.assign(item, item.status['changeUser'])
        }
      },
      compare (a, b) {
        let statusA = a.id_text.toUpperCase()
        let statusB = b.id_text.toUpperCase()
        let comparison = 0
        if (statusA > statusB) {
          comparison = 1
        } else if (statusA < statusB) {
          comparison = -1
        }
        return comparison
      },
      recalculateInterval () {
        this.recalculate = !this.recalculate
      },
      startDuration: function (item) {
        let values = {task_id: item.id, begin: moment().format('YYYY-MM-DD HH:mm:ss'), end: moment().format('YYYY-MM-DD HH:mm:ss'), id_text: item.id_text, active: true, httpDB: true}
        // Passado o httpDB para true para iniciar o tempo no banco
        // E depois passar no socket como false para não incluir no banco pelas outras abas
        this.$store.commit('stopWatch/change_values', values)
        this.$socket.emit('generalEvent', {
          data: Object.assign(values, {httpDB: false}),
          responseEvent: 'changeStopWatch',
          room: `user${this.$auth.user().id}`
        })
      },
      createSubItem: function (item) {
        this.$emit('createSubItem', item)
      },
      duplicateTask: function (id) {
        this.$emit('duplicateTask', id)
      },
      editSubItem: function (item, view) {
        this.$emit('editSubItem', item, view)
      },
      deleteSubItem: function (item) {
        this.$emit('deleteSubItem', item)
      },
      updateDatetimeEnd: function (datetime) {
        this.editedItem.end = datetime
      },
      changeAllItem: function (item, reloadFilter) {
        this.$emit('changeAllItem', item, reloadFilter)
      },
      clicked (id) {
        let element = document.getElementsByClassName('clicked')
        if (element.length > 0) {
          element[0].classList.remove('clicked')
        }
        let line = document.getElementById('line' + id)
        if (line) line.classList.add('clicked')
      },
      sequenceExpanded (sequence) {
        var sequenceExpandedIds = this.sequenceExpandedIds + (sequence ? `.${sequence}` : '')
        this.$emit('sequenceExpanded', sequenceExpandedIds)
      },
      openSubtasks (props) {
        if (!props.expanded) {
          this.$emit('sequenceExpanded', props.item.id)
          this.sequenceExpandedIds = props.item.id
          this.$store.commit('loader/change_dialog', true)
          this.loadingSubtasks = true
          // !props.item.hasOwnProperty('all_subtasks') verifica se tem o all_subtask pois ele pode se perder quando edita uma tarefa e muda a equipe ou o cliente (Ver sobe isso depois pois não deveria vir sem allsubtask)
          if (!props.item.hasOwnProperty('all_subtasks') || props.item.all_subtasks.length !== props.item.subtasks_clean_count) {
            this.$http.get(`api/get_subtasks/${props.item.id}`).then(res => {
              props.item.all_subtasks = res.body
              // Substitui a tarefa top do allItems pela do Items para inclui as subtarefas no AllItems
              this.$emit('changeAllItem', props.item)

              // Atualiza o count das subtarefas caso seja criado alguma tarefa depois que já está carregada
              props.item.subtasks_clean_count = props.item.all_subtasks.length
              props.expanded = !props.expanded
              this.loadingSubtasks = false
              this.fatherId = props.item.id
              setTimeout(() => {
                this.$refs.expand.openAddTask(props.item)
              }, 500)
              this.$store.commit('loader/change_dialog', false)
            })
          } else {
            props.expanded = !props.expanded
            this.loadingSubtasks = false
            this.fatherId = props.item.id
            setTimeout(() => {
              this.$refs.expand.openAddTask(props.item)
            }, 500)
            this.$store.commit('loader/change_dialog', false)
          }
        } else {
          this.sequenceExpandedIds = null
          this.$emit('sequenceExpanded', null)
          props.expanded = !props.expanded
        }
      },
      customizedFilter (items, search, filter) {
        search = search.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        let fieldSearch = this.headers.map(function (val) {
          let reduce = val['value'].substring(0, val['value'].indexOf('.'))
          if (val['value'].indexOf('.') >= 0) {
            return [reduce, 2]
          } else {
            return [val['value'], 1]
          }
        })
        return items.filter(i => (
          fieldSearch.some(j => {
            if (j[1] === 1) {
              return i[j[0]] ? filter(i[j[0]].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), search) : false
            } else {
              return i[j[0]] ? filter(i[j[0]]['id_text'].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), search) : false
            }
          })
        ))
      }
    },
    watch: {
      pagination: {
        handler (newVal, oldVal) {
          if (oldVal.hasOwnProperty('descending')) {
            if (newVal['descending'] !== oldVal['descending'] || newVal['sortBy'] !== oldVal['sortBy']) {
              this.$emit('updateSort', newVal)
            }
          }
        },
        deep: true
      }
    },
    computed: {
      emptyTable () {
        return 'Ainda não foram cadastrados registros de ' + this.translate('table.' + this.entity + '.title')[1]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PTaskExpand.vue